/**
 * @license
 * Copyright (c) 2023 Entelechy Corporation. All rights reserved.
 */

import { html, css } from "lit";
import { property, customElement } from 'lit/decorators.js';
import { ECComponent } from "./ec-component";

@customElement('ec-spaceport')
export class ECSpacePort extends ECComponent {
  /**
   * Visual identifier (visid) of this port.
   * @attr
   */
  @property({type: String, reflect: true  })
  visid = '';

  static styles = [
    ...ECComponent.styles,
    css`
      * {
        box-sizing: border-box; /* include padding as content, preventing content overflow for 100% height/width settings */
      }
      div.visid {
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        height: 2em;
        width: 2em;
        color: var(--primary-hilite-fgcolor);
        background-color: var(--primary-hilite-bgcolor);
        border: 2px solid var(--primary-hilite-bdcolor);
        box-sizing: border-box;
        border-radius: 50%;

        position:absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      div.spacePortContainer {
        height: 100%;
        position: relative;
        border: thin solid var(--bdcolor);
      }
      .crossed {
        height: 100%;
        min-height: 2em;

        border: 1px solid var(--bdcolor);
        filter: brightness(0.5);
        background-color: var(--title-bar-bgcolor);
        background-image:
          repeating-linear-gradient(
            45deg,
            transparent,
            transparent 18px,
            var(--bdcolor) 10px,
            var(--bdcolor) 20px
          ),
          repeating-linear-gradient(
            135deg,
            transparent,
            transparent 18px,
            var(--bdcolor) 10px,
            var(--bdcolor) 20px
        );
      }
      .hide {
        visibility: hidden;
      }
      .show {
        visibility: visible;
      }
      .visidDim {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        backdrop-filter: blur(2px);
        color: var(--primary-hilite-fgcolor);
      }
    `
  ]
  
  render() {
    return html`
      <div class="spacePortContainer">
        <div class="visidDim ${this.visid === '' ? 'hide' : 'show'}"></div>
        <div class="visid ${this.visid === '' ? 'hide' : 'show'}">${this.visid}</div>
        <slot>
          <div class="crossed"/></div>
        </slot>
      </div>
      `
  }
}
